import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { EyeIcon, EyeSlashIcon } from '../../assets/icons/icons';
import logo from '../../assets/new-logo.png';
import appicon from '../../assets/new-logo.png';
import { logIn, signUp } from '../../auth';
import './style.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [name, setName] = useState('');
  const [organization, setOrganization] = useState('');
  const [error, setError] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [isSigningUp, setIsSigningUp] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [accountCreated, setAccountCreated] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setValidationErrors({});

    let errors = {};
    if (isSigningUp) {
      if (!name.trim()) errors.name = 'Name is required';
      if (!organization.trim()) errors.organization = 'Organization Name is required';
      if (!confirmPassword) errors.confirmPassword = 'Confirm Password is required';
    }
    if (!email.trim()) errors.email = 'Email is required';
    if (!password) errors.password = 'Password is required';

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    setLoading(true);
    try {
      if (isSigningUp) {
        if (password !== confirmPassword) {
          setError("Passwords do not match");
          setLoading(false);
          return;
        }
        await signUp(email, password, { username: name, org_name: organization });
        setAccountCreated(true);
      } else {
        await logIn(email, password);
        navigate('/loading'); 
      }
    } catch (err) {
      console.error('Authentication error', err);
      // map known messages to friendly text
      let friendly;
      const msg = err.message || '';
      if (msg.match(/Invalid login credentials/i)) {
        friendly = 'Incorrect email or password.';
      } else if (msg.match(/User already registered/i)) {
        friendly = 'That email is already in use.';
      } else if (msg.match(/Network error/i)) {
        friendly = 'Network error. Please check your connection.';
      } else {
        friendly = isSigningUp
          ? 'Could not create account. Please try again.'
          : 'Could not log in. Please try again.';
      }
      setError(friendly);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="write-section">
      <div className="modal-content">
        <div className="login-logo-container">
          <img src={logo} className="login-logo" alt="Logo" />
        </div>
        <h2>{isSigningUp ? 'Create your account' : ''}</h2>
        {error && <p className="error-message">{error}</p>}
        {isSigningUp && accountCreated && (
          <p className="success-message">
            Please check your email for a confirmation link.
          </p>
        )}

        <form onSubmit={handleSubmit} noValidate>
          {isSigningUp && (
            <>
              <label>Name:</label>
              <input
                type="text"
                value={name}
                onChange={e => {
                  setName(e.target.value);
                  if (validationErrors.name) setValidationErrors(p => ({ ...p, name: null }));
                }}
                placeholder="Full Name"
                className={`login-input ${validationErrors.name ? 'error' : ''}`}
              />
              {validationErrors.name && <div className="validation-error">{validationErrors.name}</div>}

              <label>Organization Name:</label>
              <input
                type="text"
                value={organization}
                onChange={e => {
                  setOrganization(e.target.value);
                  if (validationErrors.organization) setValidationErrors(p => ({ ...p, organization: null }));
                }}
                placeholder="Organization Name"
                className={`login-input ${validationErrors.organization ? 'error' : ''}`}
              />
              {validationErrors.organization && <div className="validation-error">{validationErrors.organization}</div>}
            </>
          )}

          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={e => {
              setEmail(e.target.value);
              if (validationErrors.email) setValidationErrors(p => ({ ...p, email: null }));
            }}
            placeholder="Email address"
            className={`login-input ${validationErrors.email ? 'error' : ''}`}
          />
          {validationErrors.email && <div className="validation-error">{validationErrors.email}</div>}

           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
            <label style={{ margin: 0 }}>Password:</label>
            {!isSigningUp && (
              <span
                className="forgot-password-link"
                onClick={() => navigate('/forgot-password')}
              >
                Forgot Password?
              </span>
            )}
          </div>
          <div className="password-input-container">
            <input
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={e => {
                setPassword(e.target.value);
                if (validationErrors.password) setValidationErrors(p => ({ ...p, password: null }));
              }}
              placeholder="Password"
              className={`login-input ${validationErrors.password ? 'error' : ''}`}
            />
            <span
              className="password-toggle-icon"
              onClick={() => setShowPassword(v => !v)}
            >
              {showPassword ? <EyeIcon /> : <EyeSlashIcon />}
            </span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              {validationErrors.password && <div className="validation-error" style={{ marginBottom: 0 }}>{validationErrors.password}</div>}
            </div>
          
          </div>

          {isSigningUp && (
            <>
              <label>Confirm Password:</label>
              <div className="password-input-container">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={confirmPassword}
                  onChange={e => {
                    setConfirmPassword(e.target.value);
                    if (validationErrors.confirmPassword) setValidationErrors(p => ({ ...p, confirmPassword: null }));
                  }}
                  placeholder="Confirm Password"
                  className={`login-input ${validationErrors.confirmPassword ? 'error' : ''}`}
                />
              </div>
              {validationErrors.confirmPassword && <div className="validation-error">{validationErrors.confirmPassword}</div>}
            </>
          )}

          <button type="submit" className="login-button" >
            {loading ? (
              isSigningUp ? 'Creating account...' : 'Logging in...'
            ) : (
              isSigningUp ? 'Create free account' : 'Login'
            )}
          </button>
        </form>

        {/* Render the Install App button only if the prompt event has been captured */}

        <div className='install-container'>
          <div className='install-text-container'>
              <p className='install-text'><strong>Love the SWP?</strong><br></br>Add to homesreen for best experience</p>
             <div className='app-icon-container'> 
                <img src={appicon} className='app-icon' alt="Install SWP"/>
             </div>
            
          </div>
        </div>

        <div className="toggle-auth">
        {isSigningUp ? (
        <p>
          Already have an account?{' '}
          <span onClick={() => setIsSigningUp(false)}>Sign In</span>
        </p>
        ) : (
        <>
          {/* <p>
            Don't have an account?{' '}
            <span onClick={() => setIsSigningUp(true)}>
              Create an account
            </span>
          </p> */}
          <a className="login-link" href="/privacy-policy">
            Privacy Policy
          </a>{' '}
          <a className="login-link" href="/terms-of-service">
            Terms of Service
          </a>
        </>
        )}
        </div>
      </div>
    </div>
  );
}